import Vue from "vue";

const state = {
	yeardata_options: {
		page: 1,
		itemsPerPage: null,
		sortBy: ["fullname"],
		sortDesc: [true],
		groupBy: [],
		groupDesc: [],
		mustSort: false,
		multiSort: false,
		search: null,
	},
	yeardata: {},
	_yeardata_loading: 0,
	showCreateEditYearData: false,
	currentYearData: {},
};

const getters = {
	getYearDataOptions: (state) => state.yeardata_options,
	getYearData: (state) => state.yeardata,
	yeardata_loading: (state) => state._yeardata_loading !== 0,
	showCreateEditYearData: (state) => state.showCreateEditYearData,
	getCurrentYearData: (state) => state.currentYearData,
};

const actions = {
	fetchYearData({ commit, dispatch }) {
		commit("START_YEARDATA_LOADING");
		axios
			.get("/api/admin/yeardata", { params: state.yeardata_options })
			.then((res) => {
				commit("setYearData", res.data);
			})
			.catch((err) => {
				dispatch("handleError", err);
			})
			.then(function () {
				commit("STOP_YEARDATA_LOADING");
			});
	},
	createYearData({ commit, dispatch }) {
		commit("START_YEARDATA_LOADING");
		if (!state.currentYearData.id) {
			return new Promise((resolve, reject) => {
				axios
					.post("/api/admin/yeardata", state.currentYearData)
					.then((res) => {
						dispatch("handleResponseMessage", res.data);
						if (state.showCreateEditYearData) {
							dispatch("fetchYearData");
							dispatch("hideAction", "hideCreateEditYearData");
						}
						resolve(res.data);
					})
					.catch((err) => {
						dispatch("handleError", err);
						reject(err);
					})
					.then(function () {
						commit("STOP_YEARDATA_LOADING");
					});
			});
		} else {
			return new Promise((resolve, reject) => {
				axios
					.put("/api/admin/yeardata/" + state.currentYearData.id, state.currentYearData)
					.then((res) => {
						if (res.data.object) {
							dispatch("fetchYearData");
							dispatch("hideAction", "hideCreateEditYearData");
						}
						dispatch("handleResponseMessage", res.data);
						resolve(res.data);
					})
					.catch((err) => {
						dispatch("handleError", err);
						reject(err);
					})
					.then(function () {
						commit("STOP_YEARDATA_LOADING");
					});
			});
		}
	},
	deleteYearData({ commit, dispatch }, array_ids) {
		commit("START_YEARDATA_LOADING");
		return new Promise((resolve, reject) => {
			axios
				.post("/api/admin/yeardata/delete", { array_ids: array_ids })
				.then((res) => {
					dispatch("fetchYearData");
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_YEARDATA_LOADING");
				});
		});
	},
};
const mutations = {
	setYearDataOptions(state, value) {
		Vue.set(state, "yeardata_options", value);
	},
	setYearData(state, data) {
		Vue.set(state, "yeardata", data);
	},
	START_YEARDATA_LOADING(state) {
		state._yeardata_loading++;
	},
	STOP_YEARDATA_LOADING(state) {
		state._yeardata_loading--;
	},
	showCreateEditYearData(state) {
		state.showCreateEditYearData = true;
	},
	hideCreateEditYearData(state) {
		state.showCreateEditYearData = false;
	},
	setCurrentYearData(state, value) {
		Vue.set(state, "currentYearData", value);
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
